export const transportCategories = [
  {
    value: 1,
    label: "Фура",
    className: "wagon",
  },
  {
    value: 2,
    label: "Фургон легкий (LCV)",
    className: "wagon-light",
  },
  {
    value: 3,
    label: "Грузовик 3.5т - 12т",
    className: "truck",
  },
  {
    value: 4,
    label: "Спецтехника",
    className: "special",
  },
  {
    value: 5,
    label: "Автопоезд",
    className: "road-train",
  },
];

export const transportBodyTypes = [
  {
    id: 2,
    parent_id: null,
    name: "Закрытые",
    description: "",
    parent: null,
    category: [1, 2, 3, 5],
  },
  {
    id: 3,
    parent_id: 2,
    name: "Тент",
    description: "",
    parent: 2,
    category: [],
  },
  {
    id: 4,
    parent_id: 2,
    name: "Цельномет.",
    description: "",
    parent: 2,
    category: [],
  },
  {
    id: 5,
    parent_id: 2,
    name: "Изотерм.",
    description: "",
    parent: 2,
    category: [],
  },
  {
    id: 6,
    parent_id: 2,
    name: "Рефрижератор",
    description: "",
    parent: 2,
    category: [],
  },
  {
    id: 7,
    parent_id: null,
    name: "Открытые",
    description: "",
    parent: null,
    category: [1, 2, 3, 5],
  },
  {
    id: 8,
    parent_id: 7,
    name: "Бортовой",
    description: "",
    parent: 7,
    category: [],
  },
  {
    id: 9,
    parent_id: 7,
    name: "Площадка",
    description: "",
    parent: 7,
    category: [],
  },
  {
    id: 10,
    parent_id: 7,
    name: "Трал",
    description: "",
    parent: 7,
    category: [],
  },
  {
    id: 11,
    parent_id: 7,
    name: "Самосвал",
    description: "",
    parent: 7,
    category: [],
  },
  {
    id: 12,
    parent_id: null,
    name: "Контейнерные",
    description: "",
    parent: null,
    category: [1, 3, 5],
  },
  {
    id: 13,
    parent_id: 12,
    name: "Контейнеровоз",
    description: "",
    parent: 12,
    category: [],
  },
  {
    id: 14,
    parent_id: 12,
    name: "Открытый контейнер (ОТС)",
    description: "",
    parent: 12,
    category: [],
  },
  {
    id: 15,
    parent_id: 12,
    name: "Закрытый контейнер",
    description: "",
    parent: 12,
    category: [],
  },
  {
    id: 16,
    parent_id: 12,
    name: "Танк-контейнер",
    description: "",
    parent: 12,
    category: [],
  },
  {
    id: 17,
    parent_id: null,
    name: "Цистерный",
    description: "",
    parent: null,
    category: [1, 3],
  },
  {
    id: 18,
    parent_id: 17,
    name: "Бензовоз",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 19,
    parent_id: 17,
    name: "Битумовоз",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 20,
    parent_id: 17,
    name: "Газовоз",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 21,
    parent_id: 17,
    name: "Химическая",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 22,
    parent_id: 17,
    name: "Пищевая-наливная",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 23,
    parent_id: 17,
    name: "Пищевая-сыпучая",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 24,
    parent_id: 17,
    name: "Пищевая-сыпучая",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 25,
    parent_id: 17,
    name: "Непищевая-сыпучая",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 26,
    parent_id: 17,
    name: "Иной вид цистерны",
    description: "",
    parent: 17,
    category: [],
  },
  {
    id: 27,
    parent_id: null,
    name: "Особые",
    description: "",
    parent: null,
    category: [1, 2, 3],
  },
  {
    id: 28,
    parent_id: 27,
    name: "Автовоз",
    description: "",
    parent: 27,
    category: [],
  },
  {
    id: 29,
    parent_id: 27,
    name: "Лесовоз",
    description: "",
    parent: 27,
    category: [],
  },
  {
    id: 30,
    parent_id: 27,
    name: "Скотовоз",
    description: "",
    parent: 27,
    category: [],
  },
  {
    id: 31,
    parent_id: 27,
    name: "Зерновоз",
    description: "",
    parent: 27,
    category: [],
  },
  {
    id: 32,
    parent_id: 27,
    name: "Тушевоз",
    description: "",
    parent: 27,
    category: [],
  },
  {
    id: 33,
    parent_id: 27,
    name: "Тягач с водителем",
    description: "",
    parent: 27,
    category: [],
  },
  {
    id: 34,
    parent_id: 27,
    name: "Иной кузов",
    description: "",
    parent: 27,
    category: [],
  },
  {
    id: 35,
    parent_id: null,
    name: "Спецтехника",
    description: "",
    parent: null,
    category: [4],
  },
  {
    id: 36,
    parent_id: 35,
    name: "Самосвал",
    description: "",
    parent: 35,
    category: [],
  },
  {
    id: 37,
    parent_id: 35,
    name: "Экскаватор",
    description: "",
    parent: 35,
    category: [],
  },
  {
    id: 38,
    parent_id: 35,
    name: "Эвакуатор",
    description: "",
    parent: 35,
    category: [],
  },
  {
    id: 39,
    parent_id: 35,
    name: "Трактор",
    description: "",
    parent: 35,
    category: [],
  },
  {
    id: 40,
    parent_id: 35,
    name: "Бульдозер",
    description: "",
    parent: 35,
    category: [],
  },
  {
    id: 41,
    parent_id: 35,
    name: "Погрузчик",
    description: "",
    parent: 35,
    category: [],
  },
];

export const transportType = (type) => {
  if (!type) {
    return "";
  }
  const transportType = transportCategories.find((c) => +c.value == +type);
  if (!transportType) {
    return null;
  }
  return transportType;
};

export const bodyType = (type) => {
  if (!type) {
    return "";
  }
  const transportType = transportBodyTypes.find((c) => +c.id == +type);
  if (!transportType) {
    return null;
  }
  return transportType.name;
};
